import { NewInterface } from "@/model/views/New";
import { OrderPrice } from "@/model/price";
import { DELIVERY_ADDRESS } from "@/model/delivery";
import { mapDeliveryMethod } from "@/gateway/request/utils";
import { optionCardCaseShow, optionTraceShow } from "@/model/views/display";

const mapFrontSide: Function = (f: NewInterface): object => {
  return {
    frontSideDesignNo: f.designSamples.frontSideDesignNo,
    frontSideColor: f.designSamples.frontSideColor,
    frontSideName: f.frontSideDescription.name,
    frontSideKana: f.frontSideDescription.kana,
    frontSideCompany: f.frontSideDescription.company,
    frontSideDivision: f.frontSideDescription.division,
    frontSideZipcode: f.frontSideDescription.zipcode,
    frontSideAddress: f.frontSideDescription.address,
    frontSideTel: f.frontSideDescription.tel,
    frontSideFax: f.frontSideDescription.fax,
    frontSideMobile: f.frontSideDescription.mobile,
    frontSideEmailList: f.frontSideDescription.emailList,
    frontSideUrlList: f.frontSideDescription.urlList,
    frontSideRequest: f.frontSideDescription.request,
    frontSideFont: f.frontSideDescription.font,
    frontSideQr: f.frontSideDescription.qr,
    frontSideQrDescription: f.frontSideDescription.qr
      ? f.frontSideDescription.qrDescription
      : "",
    frontSideQrFile1: f.frontSideDescription.qr
      ? f.frontSideDescription.qrFile1
      : "",
    frontSideQrFile2: f.frontSideDescription.qr
      ? f.frontSideDescription.qrFile2
      : "",
    frontSideQrFile3: f.frontSideDescription.qr
      ? f.frontSideDescription.qrFile3
      : "",
    frontSideQrFile4: f.frontSideDescription.qr
      ? f.frontSideDescription.qrFile4
      : "",
    frontSideLogo: f.frontSideDescription.logo,
    frontSideLogoFile1: f.frontSideDescription.logo
      ? f.frontSideDescription.logoFile1
      : "",
    frontSideLogoFile2: f.frontSideDescription.logo
      ? f.frontSideDescription.logoFile2
      : "",
    frontSideLogoFile3: f.frontSideDescription.logo
      ? f.frontSideDescription.logoFile3
      : "",
    frontSideLogoFile4: f.frontSideDescription.logo
      ? f.frontSideDescription.logoFile4
      : ""
  };
};

const mapBackSide: Function = (f: NewInterface): object => {
  if (
    !f.designSamples.backSideDesignNo ||
    !f.backSideDescriptionSelector.selector
  ) {
    return {
      backSideDesignNo: f.designSamples.backSideDesignNo,
      backSideColor: f.designSamples.backSideColor,
      backSideName: "",
      backSideKana: "",
      backSideCompany: "",
      backSideDivision: "",
      backSideZipcode: "",
      backSideAddress: "",
      backSideTel: "",
      backSideFax: "",
      backSideMobile: "",
      backSideEmailList: [],
      backSideUrlList: [],
      backSideRequest: "",
      backSideFont: "",
      backSideQr: false,
      backSideQrDescription: "",
      backSideLogo: false,
      backSideLogoFile1: "",
      backSideLogoFile2: ""
    };
  }

  if (f.backSideDescriptionSelector.selector === "自由入力フォームで作成する") {
    return {
      backSideDesignNo: f.designSamples.backSideDesignNo,
      backSideColor: f.designSamples.backSideColor,
      backSideName: "",
      backSideKana: "",
      backSideCompany: "",
      backSideDivision: "",
      backSideZipcode: "",
      backSideAddress: "",
      backSideTel: "",
      backSideFax: "",
      backSideMobile: "",
      backSideEmailList: [],
      backSideUrlList: [],
      backSideRequest: f.freeBackSideDescription.request,
      backSideFont: f.freeBackSideDescription.font,
      backSideQr: f.freeBackSideDescription.qr,
      backSideQrDescription: f.freeBackSideDescription.qr
        ? f.freeBackSideDescription.qrDescription
        : "",
      backSideQrFile1: f.freeBackSideDescription.qr
        ? f.freeBackSideDescription.qrFile1
        : "",
      backSideQrFile2: f.freeBackSideDescription.qr
        ? f.freeBackSideDescription.qrFile2
        : "",
      backSideQrFile3: f.freeBackSideDescription.qr
        ? f.freeBackSideDescription.qrFile3
        : "",
      backSideQrFile4: f.freeBackSideDescription.qr
        ? f.freeBackSideDescription.qrFile4
        : "",
      backSideLogo: f.freeBackSideDescription.logo,
      backSideLogoFile1: f.freeBackSideDescription.logo
        ? f.freeBackSideDescription.logoFile1
        : "",
      backSideLogoFile2: f.freeBackSideDescription.logo
        ? f.freeBackSideDescription.logoFile2
        : "",
      backSideLogoFile3: f.freeBackSideDescription.logo
        ? f.freeBackSideDescription.logoFile3
        : "",
      backSideLogoFile4: f.freeBackSideDescription.logo
        ? f.freeBackSideDescription.logoFile4
        : ""
    };
  }

  return {
    backSideDesignNo: f.designSamples.backSideDesignNo,
    backSideColor: f.designSamples.backSideColor,
    backSideName: f.backSideDescription.name,
    backSideKana: f.backSideDescription.kana,
    backSideCompany: f.backSideDescription.company,
    backSideDivision: f.backSideDescription.division,
    backSideZipcode: f.backSideDescription.zipcode,
    backSideAddress: f.backSideDescription.address,
    backSideTel: f.backSideDescription.tel,
    backSideFax: f.backSideDescription.fax,
    backSideMobile: f.backSideDescription.mobile,
    backSideEmailList: f.backSideDescription.emailList,
    backSideUrlList: f.backSideDescription.urlList,
    backSideRequest: f.backSideDescription.request,
    backSideFont: f.backSideDescription.font,
    backSideQr: f.backSideDescription.qr,
    backSideQrDescription: f.backSideDescription.qr
      ? f.backSideDescription.qrDescription
      : "",
    backSideQrFile1: f.backSideDescription.qr
      ? f.backSideDescription.qrFile1
      : "",
    backSideQrFile2: f.backSideDescription.qr
      ? f.backSideDescription.qrFile2
      : "",
    backSideQrFile3: f.backSideDescription.qr
      ? f.backSideDescription.qrFile3
      : "",
    backSideQrFile4: f.backSideDescription.qr
      ? f.backSideDescription.qrFile4
      : "",
    backSideLogo: f.backSideDescription.logo,
    backSideLogoFile1: f.backSideDescription.logo
      ? f.backSideDescription.logoFile1
      : "",
    backSideLogoFile2: f.backSideDescription.logo
      ? f.backSideDescription.logoFile2
      : "",
    backSideLogoFile3: f.backSideDescription.logo
      ? f.backSideDescription.logoFile3
      : "",
    backSideLogoFile4: f.backSideDescription.logo
      ? f.backSideDescription.logoFile4
      : ""
  };
};

const mapOptions: Function = (f: NewInterface): object => {
  return {
    optionCardCase: optionCardCaseShow([
      { numberOfPrints: f.numberOfPrints.numberOfPrints },
      ...f.newNthOrderList
    ])
      ? f.availabilityOfOptions.businessCardCase
      : "",
    optionRoundShape: f.availabilityOfOptions.roundShapeProcessing,
    optionTrace: optionTraceShow(
      f.frontSideDescription.logo,
      f.backSideDescription.logo,
      f.freeBackSideDescription.logo
    )
      ? f.availabilityOfOptions.logoTrace
      : ""
  };
};

const mapDeliveryTo: Function = (f: NewInterface): object => {
  switch (true) {
    case f.productDeliveryAddress.deliveryAddress ===
      DELIVERY_ADDRESS.OTHER_ADDRESS:
      return {
        deliveryTo: f.productDeliveryAddress.deliveryAddress,
        deliveryName: f.productDeliveryAddress.name,
        deliveryKana: f.productDeliveryAddress.kana,
        deliveryCompany: f.productDeliveryAddress.company,
        deliveryZipcode: f.productDeliveryAddress.zipcode,
        deliveryAddress: f.productDeliveryAddress.address,
        deliveryTel: f.productDeliveryAddress.tel,
        deliveryFax: "",
        deliveryEmail: f.productDeliveryAddress.email
      };

    case f.productDeliveryAddress.deliveryAddress ===
      DELIVERY_ADDRESS.AT_THE_STORE:
      return {
        deliveryTo: f.productDeliveryAddress.deliveryAddress,
        deliveryName: f.productDeliveryAddress.name,
        deliveryKana: "",
        deliveryCompany: "",
        deliveryZipcode: "",
        deliveryAddress: "",
        deliveryTel: f.productDeliveryAddress.tel,
        deliveryFax: "",
        deliveryEmail: f.productDeliveryAddress.email
      };

    default:
      throw new Error("Unexpected route was called.");
  }
};

const map: Function = (f: NewInterface, o: OrderPrice): object => {
  return Object.assign(
    {
      paperName: f.paper.name,
      paperThickness: f.paper.thickness,
      numberOfPrints: f.numberOfPrints.numberOfPrints,
      backSideSelector: f.backSideDescriptionSelector.selector,
      nthOrderList: f.newNthOrderList,
      paymentMethod: f.paymentMethod.method,
      confirmationMethod: f.confirmationOfTheFinishedImage.confirmationMethod,
      confirmationMethodFax:
        f.confirmationOfTheFinishedImage.confirmationMethod === "FAXで確認する"
          ? f.confirmationOfTheFinishedImage.fax
          : "",
      question: f.questions.question,

      // 金額
      ...o,

      zeusToken: f.submitBtn.token,
      zeusCardName: f.submitBtn.cardName
    },
    mapFrontSide(f),
    mapBackSide(f),
    mapOptions(f),
    mapDeliveryTo(f),
    mapDeliveryMethod(
      f.productDeliveryAddress.deliveryAddress,
      f.productDeliveryMethod
    )
  );
};

export default {
  map
};
